import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { InputGroup } from 'react-bootstrap';

import { useState, useEffect } from 'react';
import RecipeDisplay from './RecipeDisplay';
import { Modal } from 'react-bootstrap';

import api_url from '../../config/api_url';
import { authHeaders } from '../../utils/authHeaders';


const RecipeList = () => {

    const [recipes, setRecipes] = useState([{name: ""}]);
    const [param, setParam] = useState("");
    const [show, setShow] = useState(false);
    const [currentIdx, setCurrentIdx] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    useEffect(() => {
        let isSubscribed = true;

        // declare the async data fetching function
        const fetchData = async () => {
          // get the data from the api
          

          const fetchUrl = api_url + "/api/recipes" + (param.length>0? "/" + param : "");
          const data = await fetch(fetchUrl);
          const json = await data.json();
          console.log("recipe data:");
          console.log(json);
          //const data = [{name: "abc", id: 1, price:"12dkk",}, {name: "efg", id: 2, price:"12dkk"}, {name:param, id: 3, price:"14dkk"} ]
          // convert the data to json
          //const json = await response.json();
        
          // set state with the result if `isSubscribed` is true
          if (isSubscribed) {
            setRecipes(json);
          }
        }
      
        // call the function
        fetchData()
          // make sure to catch any error
          .catch(console.error);;
      
        // cancel any future `setData`
        return () => isSubscribed = false;
      }, [param])


    const removeHandler = (idx) => {
        handleShow();
        setCurrentIdx(idx);
    }

    const editHandler = async (idx, obj) => {
        if(obj.id !== undefined) {
            const response = await fetch(api_url + '/api/recipes', {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...authHeaders()
                },
                body: JSON.stringify({recipe: obj})
              });

        } else {

            const response = await fetch(api_url + '/api/recipes', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...authHeaders()
                },
                body: JSON.stringify({recipe: obj})
              });
              let json = await response.json();
              obj = json;
        }
        

        setRecipes([
            ...recipes.slice(0, idx),
            obj,
            ...recipes.slice(idx +1 )
        ]);


    }

    const deleteRecipe = async () => {
        handleClose();
        console.log(recipes);
        console.log(currentIdx);
        console.log(recipes[currentIdx]);

        const response = await fetch(api_url + '/api/recipes', {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...authHeaders()
            },
            body: JSON.stringify({id: recipes[currentIdx].id})
          });

        


        setRecipes([
            ...recipes.slice(0, currentIdx),
            ...recipes.slice(currentIdx + 1)
          ]);
    }

    const addNewRecipe = () => {
        setRecipes([...recipes, {name:""}])
    }
    

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Slet Opskrift</Modal.Title>
                </Modal.Header>
                <Modal.Body>Er du sikker på du vil slette opskriften {recipes.length > 0 ? recipes[currentIdx].name : "ERROR"}?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Tilbage
                    </Button>
                    <Button variant="primary" onClick={deleteRecipe}>
                        Slet
                    </Button>
                </Modal.Footer>
            </Modal>

        <Row className="justify-content-center">
        <Row>
            <Col xs={10}>
                <Button onClick={addNewRecipe}>Tilføj en ny opskrift</Button>
            </Col>
        </Row>
        </Row>
            {recipes.length > 0 ? recipes.map((recipeObj, i) => <RecipeDisplay obj={recipeObj} key={i} index={i} deleteFunction={removeHandler} editFunction={editHandler} recipeId={recipeObj.id} />) : null}
        </>
        
    );

}

export default RecipeList;